import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SLICE } from 'ducks/slice';

import { settings_default } from './defaults';
import { Settings } from './types';

const initialState: Settings = { ...settings_default };

export const settingsSlice = createSlice({
  name: SLICE.SETTINGS,
  initialState,
  reducers: {
    updateSettings: (state, action: PayloadAction<Partial<Settings>>) => ({
      ...state,
      ...action.payload,
    }),
  },
});

export const { updateSettings } = settingsSlice.actions;

export default settingsSlice.reducer;
